import { useState } from "react";
import { Download, Share, X } from "lucide-react";
import { useInstallPrompt } from "@/lib/pwa";

const KEY = "install_banner_dismissed";

export function InstallBanner() {
  const { canPrompt, install, installed, ios } = useInstallPrompt();
  const [hidden, setHidden] = useState(() => localStorage.getItem(KEY) === "1");
  if (hidden || installed || (!canPrompt && !ios)) return null;
  const dismiss = () => { localStorage.setItem(KEY, "1"); setHidden(true); };
  return (
    <div className="mb-4 flex items-center gap-3 rounded-xl bg-sky-50 px-3 py-2.5 text-sm text-sky-900 md:hidden" data-testid="install-banner">
      <img src="/icon-192.png" alt="" className="h-9 w-9 shrink-0 rounded-lg" />
      <div className="min-w-0 flex-1">
        <p className="font-semibold">Install DreamCRM</p>
        {ios && !canPrompt
          ? <p className="text-xs text-sky-800">Tap <Share className="inline h-3.5 w-3.5" /> Share, then "Add to Home Screen"</p>
          : <p className="text-xs text-sky-800">Open it full-screen from your home screen</p>}
      </div>
      {canPrompt && <button onClick={async () => { if (await install()) dismiss(); }} className="inline-flex shrink-0 items-center gap-1 rounded-lg bg-sky-600 px-3 py-1.5 text-xs font-semibold text-white" data-testid="install-banner-btn"><Download className="h-3.5 w-3.5" />Install</button>}
      <button onClick={dismiss} className="shrink-0 rounded p-1 text-sky-700 hover:bg-sky-100" title="Dismiss" data-testid="install-banner-dismiss"><X className="h-4 w-4" /></button>
    </div>
  );
}

export function InstallAppCard() {
  const { canPrompt, install, installed, ios } = useInstallPrompt();
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid="install-app-card">
      <div className="flex items-center gap-3">
        <img src="/icon-192.png" alt="" className="h-10 w-10 rounded-lg" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-slate-800">Install app</p>
          <p className="text-xs text-slate-500">
            {installed ? "DreamCRM is installed on this device." : canPrompt ? "Add DreamCRM to your home screen or desktop so it opens like an app."
              : ios ? 'On iPhone/iPad: tap the Share button in Safari, then "Add to Home Screen".'
              : 'Use your browser menu and choose "Install app" or "Add to Home Screen".'}
          </p>
        </div>
        {canPrompt && !installed && <button onClick={install} className="inline-flex shrink-0 items-center gap-1.5 rounded-lg bg-sky-600 px-3 py-2 text-xs font-semibold text-white hover:bg-sky-700" data-testid="install-app-btn"><Download className="h-4 w-4" />Install</button>}
      </div>
    </div>
  );
}
